import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import { API_MEDIA } from "../../env";
export default function MultiActionAreaCard() {
  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="140"
          image={`${API_MEDIA}/media/foto/stat.png`}
          alt="green iguana"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            Статистика Федерации
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Колличество выступающих спортсменов по годам
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
